import { useQuery } from '@apollo/client'
import { useState } from 'react'
import {
  Icon,
  IconType,
  ListReviews,
  Loader,
  Slider,
} from '../../../../components'
import { Divider } from '../../../../components/Divider'
import { Avatar } from '../../../../elements'
import { Creator, Pagination, Rating, RatingType } from '../../../../gql/types'
import { GET_RATINGS } from '../../../../gql'

interface IProps {
  open: boolean
  setOpen: any
  creator: Creator
  className?: string
}

interface GetRatings {
  getRatings: {
    items: Rating[]
    pagination: Pagination
  }
}

const ViewReviewsSliderPublic = ({ open, setOpen, creator }: IProps) => {
  const limit = 6
  const [skip, setSkip] = useState(0)

  const {
    loading: getRatingsLoading,
    error: getRatingsError,
    data: getRatingsData,
  } = useQuery<GetRatings>(GET_RATINGS, {
    variables: {
      options: {
        filters: {
          creatorId: creator?.id,
          type: RatingType.brandToCreator,
        },
        skip,
        limit,
      },
    },
    skip: !creator?.id,
  })

  const setPage = (page: number) => {
    setSkip(page * limit)
  }

  return (
    <Slider setOpen={setOpen} open={open}>
      <div className='flex h-full flex-col bg-white shadow-xl'>
        {/* Header */}
        <div className='sticky top-0 z-10 bg-white'>
          <div className='px-4 pt-6 sm:px-6'>
            <div className='flex items-start justify-between'>
              <Avatar
                type='user'
                src={creator?.avatar?.url}
                size='md'
                alt={creator?.firstName}
              />
              <div className='ml-3 flex h-7 items-center'>
                <button
                  type='button'
                  className='rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none'
                  onClick={() => setOpen(false)}
                >
                  <span className='sr-only'>Close panel</span>
                  <Icon
                    type={IconType.x}
                    className='h-6 w-6'
                    aria-hidden='true'
                  />
                </button>
              </div>
            </div>
            <h3 className='text-xl font-bold text-gray-900 sm:text-2xl mt-6'>
              {creator?.firstName}'s Reviews
            </h3>
          </div>
          <Divider className='py-6' />
        </div>

        {/* Main */}
        <div className='pb-1 sm:pb-6 px-4 sm:px-6 flex-1 overflow-y-auto'>
          {getRatingsLoading && <Loader />}
          {!getRatingsLoading && !getRatingsError && (
            <ListReviews
              ratings={getRatingsData?.getRatings?.items?.map((rating) => ({
                id: `${rating.id}`,
                name: rating.brand.name,
                profilePicUrl: rating.brand.logo?.url,
                url: rating.brand.website,
                stars: rating.stars,
                review: rating.review,
                createdAt: rating.createdAt,
                avatarType: 'brand',
              }))}
              pagination={getRatingsData?.getRatings?.pagination}
              setPage={setPage}
            />
          )}
        </div>
      </div>
    </Slider>
  )
}

export { ViewReviewsSliderPublic }
